export const AUTH_API_URL = '/login';
export const REGISTER_API_URL = '/v1/customer/register/kiosk';
export const RESEND_CODE_API_URL = (userId) => `v1/customer/verify/${userId}/again`;
export const RESEND_CALL_API_URL = (userId) => `v1/customer/verify/${userId}/call`;
export const FORGET_PASSWORD_SEND_CODE_URL = 'customer/password/send-code';
export const CHANGE_PASSWORD = 'customer/password/change';
export const VERIFY_API_URL = (userId) => `/v1/customer/verify/${userId}`;
export const AUTH_LOGOUT_API_URL = '/logout';
